"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const provider_settings_1 = require("@framework/provider-settings");
const utils_1 = require("./utils");
const LocalizationProvider = (props) => {
    const { children, i18n, defaultLanguage } = props;
    const settings = (0, provider_settings_1.useSettings)();
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { defaultLocale: defaultLanguage, locale: settings.getLanguage(), messages: Object.assign((0, utils_1.flattenMessages)(i18n[defaultLanguage]), (0, utils_1.flattenMessages)(i18n[settings.getLanguage()])), children: children }));
};
exports.LocalizationProvider = LocalizationProvider;
//# sourceMappingURL=provider.js.map